import React, { useContext } from 'react';
import { CSVLink } from 'react-csv';
import { KickCounterContext } from '../../context/KickCounterContext';
import numberToStrengthString from '../../utils/strength';
import styles from './Export.module.css';

const exportIcon = require('../../assets/icons/export.svg').default;

const headers = [
  { label: 'Movement Type', key: 'kickType' },
  { label: 'Timestamp', key: 'convertedTime' },
];

const convertTime = (kickList) => kickList.map((item) => ({
  ...item,
  convertedTime: new Date(item.timestamp * 1000).toISOString().substring(11, 19),
}));

export default function Export() {
  const { kickList, strength } = useContext(KickCounterContext);
  const date = new Date();

  return (
    <CSVLink className={styles.link} data={convertTime(kickList)} headers={headers} filename={`${date.toLocaleDateString()}-(${numberToStrengthString(strength)}).csv`}>
      <img src={exportIcon} alt="" />
      Export Log
    </CSVLink>
  );
}
